import * as $ from 'jquery';


$(document).ready(function () {
    $('#sidebarCollapse').on('click', function () {
        // open or close navbar
        $('#sidebar, .header, .content_page, footer').toggleClass('active');
    });
 });